import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AJSTasksService } from 'src/admin-front/ajs-upgraded-providers';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { SitesService } from 'src/app/mobile/shared/sites.service';
import { SiteTypeEnum } from 'src/app/shared/enums';
import { MessageSender } from 'src/app/shared/models/misc.model';
import { API_URL_COMPANIES, BasicService } from 'src/app/shared/services/basic.service';
import { ScrollService } from 'src/app/shared/services/scroll.service';
import { TaskProcessService } from 'src/app/task-process/shared/task-process.service';
import { EngagementAbstractService } from '../engagement-abstract.service';

@Injectable({ providedIn: 'root' })
export class EngagementKakaotalkService extends EngagementAbstractService {
  channelType: SiteTypeEnum = SiteTypeEnum.Kakaotalk;

  constructor(
    private httpClient: HttpClient,
    alcmeonContextService: AlcmeonContextService,
    sitesService: SitesService,
    scrollService: ScrollService,
    taskProcessService: TaskProcessService,
    ajsTasksService: AJSTasksService,
    basicService: BasicService
  ) {
    super(sitesService, scrollService, taskProcessService, ajsTasksService, basicService, alcmeonContextService);
  }

  tryToFindRecipient(siteId: number, searchUserExternalType: string): Observable<MessageSender> {
    if (!searchUserExternalType || !siteId) {
      return EMPTY;
    }
    const userExternalId = searchUserExternalType.replace(/^(\+)/i, '');
    return this.httpClient
      .get<MessageSender>(
        `${API_URL_COMPANIES}/${this.companyId}/sites/${siteId}/kakaotalk/social-names/${userExternalId}`
      )
      .pipe(
        catchError(error => {
          if (error.status === 404) {
            const recipient = { name: searchUserExternalType, external_id: searchUserExternalType } as MessageSender;
            return of(recipient);
          }
          throwError(error);
        }),
        map(recipient => {
          this.taskProcessContext.from = recipient;
          this.userProfileBS.next(true);
          return recipient;
        })
      );
  }
}
